import { Injectable } from "@angular/core";
import { Observable, catchError, throwError, of } from "rxjs";
import { User, UserData, environment } from "src/index";
import { UserService } from "src/core/index/services.index";

const profileKeys = Object.freeze({
  amazon: {
    domain: "amazon.it",
    sectorData: "amazon_actionaid"
  },
  actionAid: {
    domain: "actionaid.org",
    sectorData: "amazon_actionaid"
  },
  alexa: {
    domain: "alexa.it",
    sectorData: "amazon_actionaid"
  },
  amazonDotCom: {
    domain: "amazon.com",
    sectorData: "amazon_actionaid"
  },
  alexaDotCom: {
    domain: "alexa.com",
    sectorData: "amazon_actionaid"
  },
})

@Injectable({
  providedIn: 'root'
})
export class UserServiceCustom extends UserService {
  override registration(newUserData: Object): Observable<{ access_token: string, user: User } | undefined> {
    if (environment.registration) {
      const customUserData = newUserData as UserData;
      if (!customUserData["data"]) {
        customUserData["data"] = {};
      }
      const emailDomain = customUserData["email"]?.split("@")[1];
      switch (emailDomain) {
        case profileKeys.amazon.domain:
        case profileKeys.amazonDotCom.domain:
        case profileKeys.alexa.domain:
        case profileKeys.alexaDotCom.domain:
          customUserData["data"].sector = profileKeys.amazon.sectorData;
          break;

        case profileKeys.actionAid.domain:
          customUserData["data"].sector = profileKeys.actionAid.sectorData;
          break;

        default:
          customUserData["data"].sector = "external";
          break;
      }

      return this.http.post<{ access_token: string, user: User }>(environment.registration, customUserData).pipe(
        catchError(error => throwError(() => error.error.message)),
      );
    }

    return of(undefined);
  }
}
